/** The site's error page: a missing page, or one that failed to render. */
export function ErrorState({
  status,
  preview = false,
  creatorName = "Drate",
}: {
  status: 404 | 500;
  /** The owner's preview of this page from the dashboard. */
  preview?: boolean;
  creatorName?: string;
}) {
  const missing = status === 404;
  return (
    <section className="error-page" aria-labelledby="error-title">
      <div className="error-orbit" aria-hidden="true">
        <span>{status}</span>
      </div>
      <div className="container error-content">
        {preview && <span className="preview-chip">Dashboard preview</span>}
        <p className="eyebrow">Error {status}</p>
        <h1 id="error-title">
          {missing ? "This path wandered off." : "We hit an unexpected snag."}
        </h1>
        <p className="lead">
          {missing
            ? `That page isn’t part of ${creatorName}, or it may have moved.`
            : "Nothing you did caused this. Try again in a moment, or head home and keep exploring."}
        </p>
        <div className="actions">
          <a href="/" className="button button-primary">
            Back home <span aria-hidden="true">→</span>
          </a>
          {!missing && (
            <button
              className="button button-outline"
              type="button"
              data-retry=""
              onClick={() => location.reload()}
            >
              Try again
            </button>
          )}
        </div>
        <p className="error-note">
          {missing
            ? "The rest of the site is still right where you left it."
            : "If this keeps happening, come back a little later."}
        </p>
      </div>
    </section>
  );
}
